import cn from "classnames";
import type { ComponentProps } from "react";
import { Icon } from "../common/Icon";
import styles from "./Tag.module.css";

type ItemProps = {
	name: string;
	onRemove?: () => void;
};

function Tag({ name, onRemove }: ItemProps) {
	return (
		<div className={styles.tag}>
			{name}
			{onRemove && (
				<button className={styles.remove} onClick={onRemove} type="button">
					<Icon name="close" size={20} />
				</button>
			)}
		</div>
	);
}

function TagList(props: ComponentProps<"div">) {
	const { className, ...rest } = props;
	return <div className={cn(styles.list, className)} {...rest} />;
}

function TagIconButton(
	props: ComponentProps<"button"> & {
		icon: ComponentProps<typeof Icon>["name"];
	},
) {
	const { className, icon, ...rest } = props;
	return (
		<button
			type="button"
			className={cn(styles.iconButton, className)}
			{...rest}
		>
			<Icon name={icon} size={18} />
		</button>
	);
}

const TagNamespace = Object.assign(Tag, {
	List: TagList,
	IconButton: TagIconButton,
});

export { TagNamespace as Tag };
